import { ReportResultBaseModel } from '@treasury/domain/reports/report-results.entity';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/tm-loader';
import { css, html, nothing, type TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../balance/balance-report-summary';
import '../transaction/transaction-report-summary';

export const tagName = 'report-summary';
@customElement(tagName)
export class ReportSummary extends TmBaseComponent {
    @property()
    public report!: ReportResultBaseModel;

    @state()
    private summary: TemplateResult | typeof nothing = nothing;

    public render() {
        if (!this.report) {
            return nothing;
        }
        return html`<div class="flex w-full justify-around overflow-scroll">${this.summary}</div>`;
    }

    protected updated(changedProps: Map<string | number | symbol, unknown>) {
        if (changedProps.has('report') && this.report) {
            this.getSummary();
        }
    }

    private getSummary() {
        if (this.report.title?.toLowerCase().includes('balance')) {
            this.summary = html`<balance-report-summary
                .report=${this.report}
            ></balance-report-summary>`;
        } else if (this.report.title?.toLowerCase().includes('transaction')) {
            this.summary = html`<transaction-report-summary
                .report=${this.report}
            ></transaction-report-summary>`;
        } else {
            // no summary in Channel for EDI reports, but I suspect product will want to come up with one
            // this.summary = ediReportSummary(this.report);
        }
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: ReportSummary;
    }
}
